import {
  ApplicationUIState,
  applicationUiReducer,
} from './application/application-ui.reducer';
import {
  ProjectIndexUiState,
  projectIndexUIReducer,
} from './project-index/project-index-ui.reducer';
import { StageUIState, stageUIReducer } from './stage/stage-ui.reducer';
import {
  combineReducers,
  ActionReducer,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { projectUIReducer, ProjectUIState } from './project/project-ui.reducer';
import { TableUIState } from './study-table-ui.model';
import { IAppState, RouterStateUrl } from '@core/state/state.service';
import { studiesUIReducer } from '@app/core/state/ui/study/study-ui.reducer';
import { SearchUploadsState, searchUIReducer } from './search/search-ui.reducer';
import {
  dataExportReducer,
  DataExportUiState,
} from './data-export/data-export.reducer';
import {
  adminUiReducer,
  AdminUiState,
} from '@core/state/ui/admin/admin-ui.reducer';
import {
  dataExportRequestReducer,
  IDataExportRequest,
} from '@core/state/entities/data-export-request/data-export-request.reducer';
import { defaultEntityState, IEntityState } from '@core/state/entities/entity';

export interface UIState {
  application: ApplicationUIState;
  admin: AdminUiState;
  dataExport: DataExportUiState;
  project: ProjectUIState;
  projectIndex: ProjectIndexUiState;
  search: SearchUploadsState;
  studies: TableUIState;
  stage: StageUIState;
}

export type UiStateSlice =
  | ApplicationUIState
  | AdminUiState
  | DataExportUiState
  | ProjectUIState
  | ProjectIndexUiState
  | SearchUploadsState
  | TableUIState
  | StageUIState;
type Application = 'application';
type Project = 'project';
type ProjectIndex = 'projectIndex';
type Studies = 'studies';
type Stage = 'stage';
type Search = 'search';
type Admin = 'admin';
type DataExportRequest = 'dataExportRequest';
export type UiStateKeys =
  | Admin
  | Application
  | DataExportRequest
  | Project
  | ProjectIndex
  | Studies
  | Search
  | Stage;
export const uiReducer: ActionReducer<UIState> = combineReducers({
  application: applicationUiReducer,
  admin: adminUiReducer,
  dataExport: dataExportReducer,
  project: projectUIReducer as ActionReducer<ProjectUIState>,
  projectIndex: projectIndexUIReducer as ActionReducer<ProjectIndexUiState>,
  search: searchUIReducer as ActionReducer<SearchUploadsState>,
  studies: studiesUIReducer as ActionReducer<TableUIState>,
  stage: stageUIReducer as ActionReducer<StageUIState>,
});

export const selectUIState = createFeatureSelector<UIState>('ui');
export const selectRouterState = (state: IAppState): RouterStateUrl =>
  state?.router?.state;
type UIStateKey = keyof UIState;
export const selectUISlice = <TKey extends UIStateKey>(key: TKey) =>
  createSelector(selectUIState, (uiState: UIState) => uiState[key]);
